import React from 'react';

const RegisterForm = ({
  firstName, setFirstName,
  lastName, setLastName,
  email, setEmail,
  registerPassword, setRegisterPassword,
  confirmRegisterPassword, setConfirmRegisterPassword,
  agreedToTerms,
  onRegister,
  onBack,
  onShowTerms,
  errorMessage,
  registrationInProgress
}) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && agreedToTerms && !registrationInProgress) {
      onRegister();
      e.preventDefault();
    }
  };

  return (
    <div className="register-container">
      <input
        className="login-input"
        type="text"
        placeholder="First Name"
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        onKeyDown={handleKeyPress}
      />
      <input
        className="login-input"
        type="text"
        placeholder="Last Name"
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
        onKeyDown={handleKeyPress}
      />
      <input
        className="login-input"
        type="text"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={handleKeyPress}
      />
      <input
        className="login-input"
        type="password"
        placeholder="Password"
        value={registerPassword}
        onChange={(e) => setRegisterPassword(e.target.value)}
        onKeyDown={handleKeyPress}
      />
      <input
        className="login-input"
        type="password"
        placeholder="Confirm Password"
        value={confirmRegisterPassword}
        onChange={(e) => setConfirmRegisterPassword(e.target.value)}
        onKeyDown={handleKeyPress}
      />

      <div className="terms-agreement">
        <button className="terms-link-button" onClick={onShowTerms}>
          By creating an account, I confirm that I have read and agree to the Terms of Service, Privacy Policy, and Disclaimer.
        </button>
        {agreedToTerms ? (
          <span className="terms-check-confirmed">✅ Agreed</span>
        ) : (
          <span className="terms-check-missing">❌ Not agreed</span>
        )}
      </div>

      <button
        className="start-button"
        onClick={onRegister}
        disabled={!agreedToTerms || registrationInProgress}
      >
        Create Account
      </button>
      <button className="secondary-button" onClick={onBack}>
        ← Back to Login
      </button>

      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </div>
  );
};

export default RegisterForm;
